<template>
  <div class="mb-3">
    <label for="">{{ 'Header' | translate }}</label>
    <input
      class="form-control"
      type="text"
      v-model="block.header"
      :placeholder="$t('Header')"
      maxlength="200"
    />
  </div>
</template>

<script>
export default {
  props: ['block'],
  methods: {},
}
</script>
